let config = {
	id: null,
	env: null,
	router: null,
	scriptSrc: 'https://connect.facebook.net/en_US/fbevents.js',
}

function loadScript() {
	window.addEventListener(
		'load',
		function (e) {
			const script = document.createElement('script')

			script.src = config.scriptSrc

			document.head.appendChild(script)
		},
		{ once: true },
	)
}

function createMetrika(Vue) {
	let n = window.fbq

	n =
		n ??
		(window.fbq = function () {
			n.callMethod
				? n.callMethod.apply(n, arguments)
				: n.queue.push(arguments)
		})

	if (!window._fbq) window._fbq = n
	n.push = n
	n.loaded = !0
	n.version = '2.0'
	n.queue = []

	n('init', config.id)

	return (Vue.prototype.$fbq = Vue.$fbq = n)
}

function startTracking(metrika) {
	if (config.router)
		config.router.afterEach(function (to, from) {
			metrika('track', 'PageView')
		})
}

export default function (Vue, options = {}) {
	config = { ...config, ...options }
	startTracking(createMetrika(Vue))

	if (config.id && config.env === 'production') {
		loadScript()
	}
}
